import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FieldType } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { ChildFieldToProfileField } from '../../../../helpers/to-profile-field/to-profile-field.helper';
import { ShComplexMapReadonlyFieldComponent } from '../complex-map-readonly-field/complex-map-readonly-field.component';

@Component({
    selector: 'sh-timer-readonly-field',
    templateUrl: '../complex-map-readonly-field/complex-map-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShTimerReadonlyFieldComponent extends ShComplexMapReadonlyFieldComponent {
    public static override readonly IS_COMPLEX: boolean = true;

    initChildProfileFieldsStream(): void {
        // Convert child definitions to profile fields
        // Only show the DateFields
        // Sort the DateFields
        this.childProfileFields$ = combineLatest([this.childDefinitions$, this.profileField$]).pipe(
            map(([children, profileField]) => children.map(child => ChildFieldToProfileField(child, profileField))),
            map(profileFields => this.filterDateFields(profileFields)),
            map(profileFields => this.sortTimerFields(profileFields))
        );
    }

    private filterDateFields(childProfileFields: ExtendedBaseProfileField[]): ExtendedBaseProfileField[] {
        return childProfileFields.filter(child => child.FieldDefinition.Type === FieldType.DateField);
    }

    // Sort the DateFields so that the EffectiveDate is always last
    private sortTimerFields(childProfileFields: ExtendedBaseProfileField[]): ExtendedBaseProfileField[] {
        return childProfileFields.sort((a, b) => {
            if (a.FieldDefinition.Key === 'EffectiveDate') {
                return 1;
            }
            if (b.FieldDefinition.Key === 'EffectiveDate') {
                return -1;
            }
            return 0;
        });
    }
}
